module.exports = __webpack_public_path__ + "media/images/icons/heartbeat-5ae2eec8c11323d008148488b995cb02.svg";